// Lib
import { DealerLMState } from 'features/Dealers/Listings/Data/state/reducer';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { FieldDefaults, LMconfig } from './types';
import { Validation } from './types';

export interface ActionGetDealerLMAPI extends Action {
    listingId: string
}

export const getDealerLMAPI = (listingId: string): ActionGetDealerLMAPI => ({
    type: ACTIONS.GET_DEALERLM_API_REQUEST,
    listingId
});

export interface ActionGetDealerLMAPISuccess extends Action {
    lmconfig: LMconfig
    defaults?: FieldDefaults
}

export const getDealerLMAPISuccess = (lmconfig: LMconfig, defaults?: FieldDefaults): ActionGetDealerLMAPISuccess => ({
    type: ACTIONS.GET_DEALERLM_API_SUCCESS,
    lmconfig,
    defaults
});

export const getDealerLMAPIError = (): Action => ({
    type: ACTIONS.GET_DEALERLM_API_ERROR,
});


export interface ActionEditLiveDealerLMInfo extends Action {
    dealerLMInfo?: LMconfig
}

export const editLiveDealerLMInfo = (dealerLMInfo?: LMconfig): ActionEditLiveDealerLMInfo => ({
    type: ACTIONS.EDIT_LIVE_DEALER_LM_INFO,
    dealerLMInfo
});

export interface ActionPostDealerLMAPI extends Action {
    listingId: string
    lmConfig: LMconfig,
    field: string
}

export const postDealerLMAPI = (listingId: string, field: string, lmConfig: LMconfig): ActionPostDealerLMAPI => ({
    type: ACTIONS.POST_DEALERLM_API_REQUEST,
    listingId,
    lmConfig,
    field
});

export interface ActionPostDealerLMAPISuccess extends Action {
    field: string,
    lmConfig: LMconfig
    validation: Validation
}

export const postDealerLMAPISuccess = (field: string, lmConfig: LMconfig, validation: Validation): ActionPostDealerLMAPISuccess => ({
    type: ACTIONS.POST_DEALERLM_API_SUCCESS,
    lmConfig,
    validation,
    field
});

export const postDealerLMAPIError = (): Action => ({
    type: ACTIONS.POST_DEALERLM_API_ERROR,
});
